import React from 'react'
import MasterFormModal from '../../generatedFormModal/MasterFormModal'

interface MasterFormModalProps {
    isEdit: boolean;
  }

const AddMaster = () => {
  return (
    <div>
      <MasterFormModal isEdit={false}/>
    </div>
  )
}

export default AddMaster


